// extracted by mini-css-extract-plugin
export default {"shell":"PreviewShell_shell__0furN"};